const getters = {
    getPaymentModes(state){
        return state.paymentModeList;
    },
    getPaymentMode(state){
        return state.paymentMode;
    }
}

export default getters;